export default __webpack_public_path__ + "static/media/ic-digital-library.907c26e3.svg";